import { SET_CALENDAR_STATUS, SET_CALENDAR_EVENTS, SET_CALENDAR_LOADING, SET_TIMELINE_EVENTS, INVALIDATE_TIMELINE } from '../constants';

interface CalendarState {
  status: Record<string, any>;
  events: Record<string, any[]>;
  loading: boolean;
  timeline: Record<string, any[]>;
  timelineFetched: Record<string, number>;
}

const initialState: CalendarState = {
  status: {},
  events: {},
  loading: false,
  timeline: {},
  timelineFetched: {},
};

export default function calendarReducer(state = initialState, action: any): CalendarState {
  switch (action.type) {
    case SET_CALENDAR_STATUS:
      return {
        ...state,
        status: { ...state.status, [action.payload.projectId]: action.payload.status },
      };
    case SET_CALENDAR_EVENTS:
      return {
        ...state,
        events: { ...state.events, [action.payload.projectId]: action.payload.events },
      };
    case SET_CALENDAR_LOADING:
      return { ...state, loading: action.payload };
    case SET_TIMELINE_EVENTS:
      return {
        ...state,
        timeline: { ...state.timeline, [action.payload.projectId]: action.payload.events },
        timelineFetched: { ...state.timelineFetched, [action.payload.projectId]: action.payload.fetchedAt },
      };
    case INVALIDATE_TIMELINE: {
      // Reset the fetched-at stamp so the next `fetchTimeline` call is forced
      // to go to the server (isStale short-circuit returns true). We keep the
      // existing events in `timeline[projectId]` so the UI doesn't flash empty
      // while the refetch is in flight.
      const projectKey = String(action.payload?.projectId ?? '');
      if (!projectKey) return state;
      const nextFetched = { ...state.timelineFetched };
      nextFetched[projectKey] = 0;
      return { ...state, timelineFetched: nextFetched };
    }
    default:
      return state;
  }
}
